"use client";

import React from "react";
import Moment from "react-moment";
import Cookies from "universal-cookie";
import ReactGA from "react-ga4";
import type { SearchQuery } from "@/types/searchquery";
import { ChaletData } from "@/types/chaletData";

interface ChaletBookingProps {
  chaletData?: ChaletData | null;
  searchQuery: SearchQuery;
  bookingUrl: string | null;
}

const cookies = new Cookies();
let gaInitialised = false;
const ChaletBooking: React.FC<ChaletBookingProps> = ({
  chaletData,
  searchQuery,
  bookingUrl,
}) => {
  const handleSubmit = () => {
    if (!chaletData) return;

    trackButtonClick(chaletData.name);
    if (bookingUrl) {
      window.open(bookingUrl, "_blank");
    } else {
      console.warn("BookingUrl Invalid.");
    }
  };

  const trackButtonClick = (chaletName: string) => {
    const cookieConsent = cookies.get("cookieconsent");

    if ((cookieConsent ?? "").toString().trim().toLowerCase() === "true") {
      if (!gaInitialised) {
        ReactGA.initialize("G-DN5MBZ5W53"); // Use your actual Measurement ID
        gaInitialised = true;
      }

      ReactGA.event("Booking_Click", {
        category: "Booking",
        action: "Booking_Click",
        label: `Chalet Booking Click for ${chaletName}`,
      });
      // console.log("GA event sent for:", chaletName);
    } else {
      // console.warn("Consent not given – GA event blocked.");
    }
  };

  const formatCurrencyGBP = (amount: number | null | undefined) => {
    return amount
      ? new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
        }).format(amount)
      : "N/A";
  };

  if (!chaletData) {
    return null;
  }

  return (
    <div>
      <div className="card shadow text-left">
        <h2 className="text-left mb-3 mt-1 font-time pl-3 pt-3">Summary</h2>
        <div className="summaryboxes pl-3">
          <div className="row mb-1">
            <div className="col-12">
              {chaletData.name} <i className="fas fa-home"></i>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col">
              Checkin:{" "}
              <Moment
                format="dddd MMM DD yyyy"
                date={searchQuery.DateFrom || ""}
              />
            </div>
          </div>

          <div className="row mb-1">
            <div className="col">
              Checkout:{" "}
              <Moment
                format="dddd MMM DD yyyy"
                date={searchQuery.DateTo || ""}
              />
            </div>
          </div>

          <div className="row mb-1">
            <div className="col">
              Price: {formatCurrencyGBP(searchQuery.TotalCost)}
            </div>
          </div>

          <div className="row text-center mb-4 mt-2 pl-3 mr-3">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary btn-lg btn-block"
              disabled={!bookingUrl}
            >
              Book this Chalet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChaletBooking;
